import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LySvgComponent } from './ly-svg.component';
import { LySvgService } from './ly-svg.service';
var LySvgModule = /** @class */ (function () {
    function LySvgModule() {
    }
    LySvgModule.forRoot = function () {
        return {
            ngModule: LySvgModule,
        };
    };
    LySvgModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [LySvgComponent],
                    declarations: [LySvgComponent],
                    providers: [LySvgService]
                },] },
    ];
    /** @nocollapse */
    LySvgModule.ctorParameters = function () { return []; };
    return LySvgModule;
}());
export { LySvgModule };
//# sourceMappingURL=ly-svg.module.js.map